import { computed } from "vue";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import { useSlotPresence } from "@/runtime/composables/useSlotPresence";
import { cardClasses } from "components/Card/card.styles";
import type { ChipProps } from "./chip.types";
import { chipClasses } from "./chip.styles";

export interface UseChipOptions {
  props: Readonly<ChipProps>;
}

export const useChip = (options: UseChipOptions) => {
  const { props } = options;
  const { default: hasDefaultSlot } = useSlotPresence(["default"]);

  const classes = computed(() => {
    const card = cardClasses({ color: props.color, variant: props.variant, size: props.size });
    const chip = chipClasses({ size: props.size, square: props.square ? "true" : "false" });
    return mergeClassProp(`${card} ${chip}`, props.class);
  });

  return { classes, hasDefaultSlot };
};
